import { Box, Grid, Link, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    lineHeight: '26pt'
  },
  button: {
    padding: theme.spacing(1)
  },
  pickup: {
    flexGrow: 1,
    textAlign: 'start'
  },
  typo: {
    padding: theme.spacing(2),
    lineHeight: '45px',
    borderColor: theme.palette.primary.main,
    border: 'solid 2px'
  }
}));

interface NoDriverDeliveryProps {
  onCancel: () => void;
  onChangeToPickupOrder: () => void;
}

const NoDriverDelivery: FC<NoDriverDeliveryProps> = ({
  onCancel,
  onChangeToPickupOrder
}: NoDriverDeliveryProps) => {
  const classes = useStyles();
  return (
    <Grid
      container
      className={classes.container}
      direction="column"
      alignContent="center"
      alignItems="center"
      justify="center"
    >
      <Box>
        <Typography variant="h5" color="error" className={classes.typo}>
          We can't find a driver to deliver your order at this time.
          <br />
          Please select an option below:
        </Typography>
        <Grid container className={classes.button}>
          <Link
            className={classes.pickup}
            variant="h6"
            color="error"
            component="button"
            onClick={onChangeToPickupOrder}
          >
            Change to Pickup Order
          </Link>
          <Link
            variant="h6"
            color="error"
            component="button"
            onClick={onCancel}
          >
            Cancel this order
          </Link>
        </Grid>
      </Box>
    </Grid>
  );
};

export default NoDriverDelivery;
